import React from 'react';
import * as styles from './modal-loading.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var ModalLoading = _ref => {
  var _ref$isAnimated = _ref.isAnimated,
    isAnimated = _ref$isAnimated === void 0 ? false : _ref$isAnimated,
    loader = _ref.loader,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading;
  if (!(loading && loader)) {
    return null;
  }
  return ___EmotionJSX("div", {
    css: styles.modalLoader(isAnimated),
    key: "loader",
    "data-testid": "modal-loader"
  }, loader);
};